import { tourKeys } from '../@utils/tourKeys'

const openPriceDrawer = () => {
    // Buscar celdas de precio que NO sean N/A (tienen precio numérico)
    const priceCells = document.querySelectorAll('.table-daily-price .container-cells')

    for (const cell of priceCells) {
        const priceText = cell.textContent.trim()
        // Si tiene un precio válido (contiene € o números) y no es "N/A"
        if (priceText && !priceText.includes('N/A') && (priceText.includes('€') || /\d/.test(priceText))) {
            cell.click()
            return
        }
    }

    // Fallback: si no hay celdas válidas, click en la primera
    if (priceCells.length > 0) priceCells[0].click()
}

const closePriceDrawer = () => {
    const backdrop = document.querySelector('.rs-drawer-backdrop.daily-price-detail')
    if (backdrop) backdrop.click()
}

export default function getCompetitionSteps() {
    const k = tourKeys('competition')

    return [
        {
            target: '.sticky-header',
            contentKey: k.welcome,
            placement: 'bottom',
            disableBeacon: true,
            disableScrolling: true,
        },
        {
            target: '.select-report-execution-header',
            contentKey: k.reportExecution,
            placement: 'bottom',
            disableScrolling: true,
        },
        {
            target: '.filter-containers',
            contentKey: k.filters,
            placement: 'bottom',
            disableScrolling: true,
        },
        {
            target: '[data-tour="competition-cards"]',
            contentKey: k.cards,
            placement: 'bottom',
        },
        {
            target: '.title-tables',
            contentKey: k.tables,
            placement: 'top',
        },
        {
            target: '.switch-table-prices',
            contentKey: k.tableSelector,
            placement: 'left',
        },
        {
            target: '[data-tour="tab-price-ranking"]',
            contentKey: k.tabPriceRanking,
            placement: 'bottom',
            disableScrolling: true,
        },
        {
            target: '[data-tour="tab-compset-ranking"]',
            contentKey: k.tabCompsetRanking,
            placement: 'bottom',
            disableScrolling: true,
        },
        {
            target: '[data-tour="tab-calendar"]',
            contentKey: k.tabCalendar,
            placement: 'bottom',
            disableScrolling: true,
        },
        {
            target: '.switch-price-night',
            contentKey: k.priceNight,
            placement: 'left',
        },
        {
            target: '.center-content',
            contentKey: k.priceClickHint,
            placement: 'top',
            data: {
                beforeNext: openPriceDrawer,
                delay: 1200,
            },
        },
        {
            target: '[data-tour="price-detail-basic"]',
            contentKey: k.priceDetailBasic,
            placement: 'bottom',
            data: {
                skipFilter: true,
                beforePrev: closePriceDrawer,
                cleanup: closePriceDrawer,
                delay: 600,
            },
        },
        {
            target: '[data-tour="price-detail-room"]',
            contentKey: k.priceDetailRoom,
            placement: 'bottom',
            data: {
                skipFilter: true,
                cleanup: closePriceDrawer,
            },
        },
        {
            target: '[data-tour="price-detail-search"]',
            contentKey: k.priceDetailSearch,
            placement: 'bottom',
            data: {
                skipFilter: true,
                cleanup: closePriceDrawer,
            },
        },
        {
            target: '[data-tour="price-detail-actions"]',
            contentKey: k.priceDetailActions,
            placement: 'top',
            data: {
                skipFilter: true,
                cleanup: closePriceDrawer,
            },
        },
        {
            target: '[data-tour="price-detail-other-prices"]',
            contentKey: k.priceDetailOtherPrices,
            placement: 'top',
            data: {
                skipFilter: true,
                cleanup: closePriceDrawer,
            },
        },
    ]
}
